/**
 * @generated SignedSource<<5ff86a85d0d0859d0682ee2d7db86f75>>
 * @relayHash 8c979458e79f0c5f416192a504b24db4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/572.0.0-2026-08-13T16:07:59.497Z/updateSaveSearchMutation

import { ConcreteRequest } from 'relay-runtime';
export type FavoriteAction = "ADD" | "REMOVE" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type FavoritePageInput = {
  action: FavoriteAction;
  clientMutationId?: string | null;
  favoriteId?: string | null;
  name?: string | null;
  page: string;
  query?: string | null;
  type: string;
  userId: string;
};
export type updateSaveSearchMutation$variables = {
  input: FavoritePageInput;
  searchPages?: ReadonlyArray<string | null> | null;
  searchTypes?: ReadonlyArray<types | null> | null;
};
export type updateSaveSearchMutation$data = {
  readonly favoritePage: {
    readonly user: {
      readonly savedSearches: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly serviceId: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type updateSaveSearchMutation = {
  response: updateSaveSearchMutation$data;
  variables: updateSaveSearchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchPages"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTypes"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "searchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "searchTypes"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "updateSaveSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": "savedSearches",
                "args": null,
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "__updateSaveSearchMutation_savedSearches_connection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "updateSaveSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": "savedSearches",
                "args": (v8/*:: as any*/),
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*:: as any*/),
                          (v9/*:: as any*/),
                          (v5/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "savedSearches",
                "args": (v8/*:: as any*/),
                "filters": [],
                "handle": "connection",
                "key": "updateSaveSearchMutation_savedSearches",
                "kind": "LinkedHandle",
                "name": "favorites"
              },
              (v9/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/572.0.0-2026-08-13T16:07:59.497Z/updateSaveSearchMutation",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "favoritePage",
            "user",
            "savedSearches"
          ]
        }
      ]
    },
    "name": "updateSaveSearchMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7167910ada06703f9182f57a9e0dd2a0";

export default node;
